import {
  getStatus,
  getIconType,
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

/**
 * Attempt to read visitor localization data from a criteria object with unknown final key.
 * Supports a few possible shapes:
 * - criteria.data.rows / criteria.data.countries
 * - criteria.data.visitorsLocCountryExts / criteria.data.countryExts
 * - criteria.data.visitorsLocPopularityMap / criteria.data.popularityMap
 *
 * @param {Object} visitorsCriteria - criteria.<visitorsLocalizationKey>
 */
export const transformVisitorsLocalization = (visitorsCriteria) => {
  if (!visitorsCriteria) {
    return {
      status: 'error',
      iconType: 'error',
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: 'No visitors localization were found.',
      data: null,
    };
  }

  const wooRankStatus = visitorsCriteria?.status || 'neutral';
  const importance = visitorsCriteria?.importance || 0;
  const solvability = visitorsCriteria?.solvability || 0;

  const d = visitorsCriteria?.data || {};

  const countryExts =
    d?.visitorsLocCountryExts ||
    d?.countryExts ||
    d?.countries ||
    d?.rows ||
    [];

  const popularityMap =
    d?.visitorsLocPopularityMap ||
    d?.popularityMap ||
    d?.map ||
    [];

  const rows = (Array.isArray(countryExts) ? countryExts : [])
    .map((r) => {
      const countryName = r?.country_name || r?.countryName || r?.country || '';
      const domain = r?.domain || '';
      const statusText = r?.status_at_friendly || r?.statusText || r?.status || '';
      if (!countryName && !domain && !statusText) return null;
      return { countryName, domain, statusText };
    })
    .filter(Boolean);

  // Map data expects ISO2 lowercase codes, like 'us', 'fr'
  const mapData = (Array.isArray(popularityMap) ? popularityMap : [])
    .map((m) => {
      const country = String(m?.country || '').trim().toLowerCase();
      const value = Number(m?.value);
      if (!country || !Number.isFinite(value)) return null;
      return { country, value };
    })
    .filter(Boolean);

  const isEmpty = rows.length === 0;

  return {
    status: getStatus(wooRankStatus),
    iconType: getIconType(wooRankStatus),
    importance: getImportance(importance),
    solvability: getSolvability(solvability),
    isEmpty,
    message: isEmpty ? 'No visitors localization were found.' : null,
    data: isEmpty ? null : { rows, mapData },
  };
};

export default transformVisitorsLocalization;


